import { Injectable } from '@angular/core';
import { Platform } from "@ionic/angular";
import * as BlinkCard from '@microblink/blinkcard-capacitor';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class CreditCardScannerService {

  isIos: boolean = false;
  public cameraLoader: any;
  private iosLicense: any;
  private androidLicense: any;

  constructor(public platform: Platform, private config: ConfigService) {
    this.checkForMobile();
    this.checkForConfigs
  }
  
  private checkForConfigs() {
    this.iosLicense = this.config?.getConfig()?.FEATURE_SCANCARD_IOS_LICENSE ?? null;
    this.androidLicense = this.config?.getConfig()?.FEATURE_SCANCARD_ANDROID_LICENSE ?? null;
  }

  async scan() {
    return new Promise(async (resolve, reject) => {
      const plugin = new BlinkCard.BlinkCardPlugin();
      const blinkCardRecognizer = new BlinkCard.BlinkCardRecognizer();
      blinkCardRecognizer.returnFullDocumentImage = true;
      let scanningResults = [];
      try {
        if (this.checkScanCardIsEnabled()) {
          const licenseKeys = {
            ios: this.iosLicense,
            android: this.androidLicense,
            showTrialLicenseWarning: false
          };

          scanningResults = await plugin.scanWithCamera(
            new BlinkCard.BlinkCardOverlaySettings(),
            new BlinkCard.RecognizerCollection([blinkCardRecognizer]),
            licenseKeys
          );
        } else {

          return reject()
        }
        resolve(scanningResults);
      } catch (error) {
        reject(error);
      }
    });
  }

  public checkScanCardIsEnabled () {
    this.checkForConfigs();
    return (this.isIos && this.iosLicense) || (!this.isIos && this.androidLicense)
  }

  private checkForMobile() {
    this.isIos = this.platform.is('ios');
  }
}